import { type PageConfig } from 'models/pages'
import { type MParticleInstance } from './internalAnalyticsProvider'

// `surface` describes where on the site the event took place
type Surface = 'embedded' | 'embedded post conversion' | 'checkout' | 'checkout post conversion'

type GlobalProperties = {
  surface: Surface
  logged_in_state: 'logged in' | 'logged out'
  mp_device_id: string | null
  page_url: string
  page_title: string
  campaign_id: string
  npo_id: string
  npo_name: string
  platform_source: 'web client' | 'mobile webview'
  // Query params
  attribution_id: string | null
  campaign_content: string | null
  campaign_medium: string | null
  campaign_name: string | null
  campaign_source: string | null
  campaign_term: string | null
}

export const buildMParticleGlobalProperties = (
  pageConfig: PageConfig,
  mParticle: MParticleInstance,
  loggedInState: boolean,
): GlobalProperties => {
  const params = new URLSearchParams(window.location.search)

  return {
    /**
     * `surface` describes where on the site the event took place
     * Most cases use "checkout", override for less common surfaces
     */
    surface: 'checkout',
    logged_in_state: loggedInState ? 'logged in' : 'logged out',
    mp_device_id: mParticle.getDeviceId(),
    page_url: window.location.href,
    page_title: document.title,
    campaign_id: pageConfig.campaignId,
    npo_id: pageConfig.orgId,
    npo_name: pageConfig.orgName,
    platform_source: 'web client',
    // Query params
    attribution_id: params.get('attribution_id'),
    campaign_content: params.get('utm_content'),
    campaign_medium: params.get('utm_medium'),
    campaign_name: params.get('utm_campaign'),
    campaign_source: params.get('utm_source'),
    campaign_term: params.get('utm_term'),
  }
}
